/* src/app/component/header-mini/header-mini.component.css */
nav {
  background-color: var(--transparent) !important;
  border-color: var(--primary-color);
}
a {
  color: var(--text-color);
  font-size: medium;
}
#menu-toggle:checked + #menu {
  display: block;
}
svg {
  color: var(--primary-color);
  fill: var(--primary-color);
}
/*# sourceMappingURL=header-mini.component.css.map */
